import { Tooltip } from "antd";
import dayjsTZ from "../../../utils/dayjs";
import {
  ApprovedIcon,
  IconNdrysho,
  UnapprovedIcon,
} from "../../../assets/icons";
import { EyeFilled, HistoryOutlined } from "@ant-design/icons";
import { checkWhetherEdited } from "../../punonjesit/EmployeeView/Payment/EmployeeShifts/utils/validations";
import { hasNoPunchTimes } from "./absenceShift";

const EYE_ICON_STYLES = {
  color: "#fff",
  padding: 3,
  borderRadius: 3,
  backgroundColor: "#1da193",
  width: "max-content",
  height: "max-content",
  marginLeft: "5px",
};

export const coldefs = ({
  dayTypes,
  clockins,
  navigate,
  showModal,
  onEditShift,
  isMobileView,
  onShiftAdminLog,
  setOpenEditDayPay,
}) => [
  {
    headerName: "Statusi",
    field: "approved",
    filter: "agTextColumnFilter",
    minWidth: 75,
    filterParams: { apply: true, newRowsAction: "keep" },
    mobile: true,
    isExported: true,
    onCellClick: () => navigate("/prezencat"),
    valueGetter: ({ data }) =>
      data?.approved === true ? "Aprovuar" : "Pa Aprovuar",
    cellRenderer: ({ data, value, node }) =>
      !node.group ? (
        !isMobileView ? (
          <div style={{ cursor: "pointer" }} onClick={() => onEditShift(data)}>
            <div variant="outlined" cursor="pointer">
              {data?.approved === true ? (
                <Tooltip
                  title={`${
                    data?.totalities?.adminLog?.approvedBy
                      ? `Aprovuar nga ${
                          data?.totalities?.adminLog?.approvedBy
                        } - ${dayjsTZ(
                          data?.totalities?.adminLog?.createdAt,
                        ).format("DD/MM/YYYY HH:mm:ss")}`
                      : ""
                  }`}
                >
                  <div className="statusIcon" style={{ background: "#1da193" }}>
                    <ApprovedIcon />
                  </div>
                </Tooltip>
              ) : data?.approved === false ? (
                <Tooltip
                  title={`${
                    data?.totalities?.adminLog?.approvedBy
                      ? `Hequr Aprovimi nga ${
                          data?.totalities?.adminLog?.approvedBy
                        } - ${dayjsTZ(
                          data?.totalities?.adminLog?.createdAt,
                        ).format("DD/MM/YYYY HH:mm:ss")}`
                      : ""
                  }`}
                >
                  <div className="statusIcon" style={{ background: "#ea3943" }}>
                    <UnapprovedIcon />
                  </div>
                </Tooltip>
              ) : (
                <div className="statusIcon" style={{ background: "grey" }}>
                  Pa Përcaktuar
                </div>
              )}
            </div>
          </div>
        ) : (
          value
        )
      ) : (
        ""
      ),
  },
  // {
  // 	headerName: "Emri",
  // 	field: "employee_details.employeeFirstName",
  // 	filterParams: {
  // 		readOnly: true,
  // 	},
  // 	// valueGetter: ({ data }) =>
  // 	// 	data?.employee_details?.employeeFirstName + " " + data?.employee_details?.employeeLastName,
  // },

  // {
  // 	headerName: "Mbiemri",
  // 	field: "employee_details.employeeLastName",
  // 	filterParams: {
  // 		readOnly: true,
  // 	},
  // },
  {
    mobile: true,
    isExported: true,
    headerName: "Punonjesi",
    field: "employeeFullName",
    filterParams: { apply: true, newRowsAction: "keep" },
    minWidth: 150,
    filter: "agTextColumnFilter",
    cellClickKey: "employeeId",
    onCellClick: ({ clickId }) => navigate(`/punonjesit/specifikat/${clickId}`),
    filterParams: { readOnly: true },
    isCollapseTitle: true,
  },
  {
    mobile: true,
    isExported: true,
    headerName: "Team",
    filterParams: { apply: true, newRowsAction: "keep" },
    minWidth: 100,
    filter: "agTextColumnFilter",
    field: "employeeTeam",
  },
  {
    headerName: "Departamenti",
    field: "employeeDepartmentName",
    mobile: true,
    isExported: true,
    minWidth: 150,
    filter: "agTextColumnFilter",
    filterParams: { apply: true, newRowsAction: "keep" },
    onCellClick: () => navigate(`/departamentet`),
  },
  {
    headerName: "Data",
    field: "data",
    isExported: true,
    filter: "agDateColumnFilter",
    sort: "desc",
    minWidth: 120,
    filterParams: {
      apply: true,
      newRowsAction: "keep",
      inRangeInclusive: true,
    },
    //formats grouped rows headers if grouped
    valueFormatter: ({ node, value }) =>
      node.group && value
        ? dayjsTZ(value).format("DD/MM/YYYY")
        : value
          ? dayjsTZ(value).format("DD/MM/YYYY")
          : "",
    format: "DD/MM/YYYY",
    mobile: true,
    //grouping by
    keyCreator: ({ value }) =>
      value ? dayjsTZ(value).format("DD/MM/YYYY") : "",
    //value for filtering
    valueGetter: ({ data }) =>
      data?.data ? dayjsTZ(data.data).toDate() : null,
    //value for displaying
    cellRenderer: ({ data }) =>
      data?.data ? dayjsTZ(data.data).format("DD/MM/YYYY") : "",
  },
  {
    headerName: "Kategoria",
    field: "dayType",
    mobile: true,
    isExported: true,
    filter: "agTextColumnFilter",
    minWidth: 120,
    filterParams: { apply: true, newRowsAction: "keep" },
    hide: false,
    valueGetter: ({ data }) => dayTypes?.[data?.dayType] || "",
  },
  {
    headerName: "Fillimi i turnit",
    field: "fillim_turni",
    filter: "agDateColumnFilter",
    minWidth: 100,
    mobile: true,
    isExported: true,
    format: "HH:mm",
    valueGetter: ({ data }) =>
      data?.fillim_turni ? dayjsTZ(data.fillim_turni).format("HH:mm") : "",
    cellRenderer: ({ data, value, node }) =>
      node.group ? null : (
        <div style={{ display: "flex", alignItems: "center" }}>
          {hasNoPunchTimes(data) ? null : value}
          {data?.clockInNote ? (
            <EyeFilled
              style={EYE_ICON_STYLES}
              onClick={(e) => showModal(e, data, "clockIn")}
            />
          ) : null}
        </div>
      ),
    filterParams: { apply: true, newRowsAction: "keep" },
  },
  {
    headerName: "Pushimi",
    field: "breakTime",
    filter: "agNumberColumnFilter",
    mobile: true,
    isExported: true,
    format: "HH:mm",
    minWidth: 120,
    valueGetter: ({ data }) => {
      let breakTime =
        (data?.breakTime?.[0] || "") + " - " + (data?.breakTime?.[1] || "");
      return breakTime;
    },
    cellRenderer: ({ value, node }) => (node.group ? null : value),
    filterParams: { apply: true, newRowsAction: "keep" },
  },
  {
    headerName: "Pushimi i paguar",
    field: "isBreakTimePaid",
    mobile: true,
    minWidth: 80,
    filter: "agNumberColumnFilter",
    valueGetter: ({ data }) => (data?.isBreakTimePaid ? "Po" : "Jo"),
    cellRenderer: ({ value, node }) => (node.group ? null : value),
    filterParams: { apply: true, newRowsAction: "keep" },
  },
  {
    headerName: "Mbarimi i turnit",
    field: "mbarim_turni",
    minWidth: 100,
    filter: "agNumberColumnFilter",
    mobile: true,
    format: "HH:mm",
    isExported: true,
    valueGetter: ({ data }) =>
      data?.mbarim_turni ? dayjsTZ(data.mbarim_turni).format("HH:mm") : "",
    cellRenderer: ({ data, value, node }) =>
      node.group ? null : (
        <div variant="outlined" cursor="pointer">
          {hasNoPunchTimes(data)
            ? null
            : value || <h1 style={{ color: "#ea3943" }}>–</h1>}
          {checkWhetherEdited(clockins, data?.clockingId, "editedClockOut") ===
            true || data?.clockOutNote ? (
            <EyeFilled
              style={EYE_ICON_STYLES}
              onClick={(e) => showModal(e, data, "clockOut")}
            />
          ) : null}
        </div>
      ),
    filterParams: { apply: true, newRowsAction: "keep" },
  },
  {
    headerName: "Orët Totale",
    field: "oret_totale",
    filter: "agNumberColumnFilter",
    minWidth: 100,
    mobile: true,
    isExported: true,
    filterParams: { apply: true, newRowsAction: "keep" },
    valueGetter: ({ data }) => data?.oret_totale || "0.00",
    cellRenderer: ({ value, node }) =>
      node.group ? null : <strong>{value}</strong>,
  },
  {
    headerName: "Krijuar",
    // field: "oret_totale",
    filter: "agDateColumnFilter",
    filterParams: { apply: true, newRowsAction: "keep" },
    minWidth: 100,
    valueGetter: ({ data }) =>
      data?.clockingLogs?.[0]?.createdAt
        ? dayjsTZ(data?.clockingLogs?.[0]?.createdAt).format("HH:mm")
        : "",
    cellRenderer: ({ value, node }) =>
      node.group ? null : (
        <span className="cellTimeWrapper">{value || "-"}</span>
      ),
  },
  {
    headerName: "Përfunduar",
    // field: "oret_totale",
    // filter: "agNumberColumnFilter",
    minWidth: 100,
    filterParams: { apply: true, newRowsAction: "keep" },
    valueGetter: ({ data }) =>
      data?.finishedAt ? dayjsTZ(data?.finishedAt).format("HH:mm") : "",
    cellRenderer: ({ value, node }) =>
      node.group ? null : (
        <span className="cellTimeWrapper">{value || "-"}</span>
      ),
  },
  {
    headerName: "employeeId",
    field: "employee_details.employeeId",
    hide: true,
    filterParams: { apply: true, newRowsAction: "keep" },
  },
  {
    headerName: "Pagesa",
    field: null,
    minWidth: 70,
    // filterParams: { apply: true, newRowsAction: "keep" },
    // cellRenderer: ({ data }) => (
    // 	<div
    // 		style={{
    // 			display: "flex",
    // 			// justifyContent: "center",
    // 			alignItems: "center",
    // 		}}
    // 		cursor="pointer"
    // 		onClick={() => onShiftAdminLog(data)}
    // 	>
    // 		<span
    // 			style={{
    // 				display: "flex",
    // 				justifyContent: "center",
    // 				alignItems: "center",
    // 				minWidth: "100px",
    // 				cursor: "pointer",
    // 				height: "22px",
    // 				marginTop: "8px",
    // 				background: "#1da193",
    // 				color: "white",
    // 				border: "none",
    // 				borderRadius: "5px",
    // 			}}
    // 			// onClick={() => onShiftAdminLog(data)}
    // 		>
    // 			Historiku
    // 		</span>
    // 	</div>
    // ),
    cellRenderer: ({ data, node }) =>
      !node.group && data?.approved === true ? (
        <div
          className="icon-ndrysho-modal-cell"
          onClick={() => setOpenEditDayPay(data)}
        >
          <IconNdrysho width={14} height={14} color="white" />
        </div>
      ) : (
        ""
      ),
  },
  // {
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   // minWidth: "100px",
  //   // cursor: "pointer",
  //   // height: "22px",
  //   // marginTop: "8px",
  //   background: "#1da193",
  //   // color: "white",
  //   // border: "none",
  //   // borderRadius: "5px",
  //   minWidth: "42px",
  //   padding: "5px",
  //   cursor: "pointer",
  //   height: "30px",
  //   marginTop: "3px",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   borderRadius: "5px",
  //   color: "white",
  // },
  {
    headerName: "Ndryshimet",
    field: null,
    minWidth: 70,
    filterParams: { apply: true, newRowsAction: "keep" },

    cellRenderer: ({ data, node }) =>
      node.group ? null : (
        <div className="cellLogWrapper" onClick={() => onShiftAdminLog(data)}>
          <HistoryOutlined />
        </div>
      ),
  },
];
